import { Fragment, useEffect } from "react";
import { useLocation } from "react-router-dom";
import SEO from "../../components/seo";
import LayoutOne from "../../layouts/LayoutOne";
import Breadcrumb from "../../wrappers/breadcrumb/Breadcrumb";
import SectionTitleWithText from "../../components/section-title/SectionTitleWithText";
import useTranslationHook from "../../hooks/useTranslationHook";
import { useParams } from "react-router-dom";
import useGetExternalPages from "../../hooks/useGetExternalPages";
import ButtonLoader from "../../components/button-loader";
import ButtonCommon from "../../components/button-common/ButtonCommon";
import DynamicComponent from "./DynamicComponet";
import { useAppSelector } from "../../hooks/useReduxMethods";

const CustomPageRouter = () => {
  let { pathname } = useLocation();
  const { pageSlug } = useParams();
  const { t } = useTranslationHook();
  const { bussinessData } = useAppSelector((state) => state.bussinessData);
  const { loading, pageInfo, getPageBySlug } = useGetExternalPages();
  useEffect(() => {
    setTimeout(() => {
      if (bussinessData) getPageBySlug(pageSlug);
    }, 500);
  }, [pageSlug, bussinessData]);

  useEffect(() => {
    console.log("PageInfo ID : ".pageInfo);
  }, [pageInfo]);
  return (
    <Fragment>
      {pageInfo && <DynamicComponent pageId={pageInfo.page_id} />}
    </Fragment>
  );
};

export default CustomPageRouter;
